import { useCallback, useMemo } from 'react'
import { Shield } from 'lucide-react'
import { useT } from '@/i18n'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { fetchAudit, type AuditRow } from '@/lib/adapters'
import { PERMISSIONS } from '@/lib/permissions'

/**
 * A18.01 — Audit jurnali.
 *
 * TZ A18 talablari (append-only, hash-chain, 3 yil saqlash, four-eyes bilan
 * eksport) SERVER tomonida bajarilishi kerak. Jonli `admin_audit` jadvali
 * oddiy INSERT — hash-chain YO'Q. Bu ekran mavjud jurnalni ko'rsatadi;
 * o'zgarmaslik kafolati alohida ish (tz/admin/HOLAT.md §2).
 *
 * Sahifa sarlavhasi `SecurityScreen` da (A18 tab qobig'i) — bu yerda
 * faqat jadval, shunda tab almashganda sarlavha sakramaydi.
 */
export function AuditTable() {
  const t = useT()

  const columns = useMemo<AdminColumn<AuditRow>[]>(
    () => [
      { key: 'created_at', header: t.col.time, type: 'date', width: 150 },
      { key: 'admin', header: t.col.staff, type: 'text', width: 160 },
      { key: 'action', header: t.col.action, type: 'text', width: 180 },
      { key: 'target', header: t.col.target, type: 'id', width: 160 },
      // Sabab/kontekst — ban sababi shu yerda ko'rinadi (yig'ilgan sabab endi
      // auditorga KO'RINADI, aks holda sabab-nazorati dekorativ bo'lardi).
      { key: 'detail', header: t.col.detail, type: 'longtext', minWidth: 200 },
      { key: 'ip', header: t.col.ip, type: 'id', width: 150, piiLevel: 'L3' },
    ],
    [t],
  )

  const fetcher = useCallback(fetchAudit, [])

  return (
    <DataTable<AuditRow>
      screenId="A18.01"
      permission={PERMISSIONS.AUDIT_VIEW}
      columns={columns}
      fetcher={fetcher}
      rowId={(r) => String(r.id ?? `${r.created_at}:${r.action}:${r.target ?? ''}`)}
      exportable
      emptyState={{ icon: <Shield size={28} strokeWidth={1.5} /> }}
    />
  )
}
